// @flow strict
import idx from 'idx'

// took these types from the rich-text typescript lib
// https://github.com/contentful/rich-text/blob/master/packages/rich-text-types/src/types.ts
//
// Generic & unsafe Node type since there don't seem to be flow-types for this lib
// $FlowIgnore
type ContentfulNodeData = { [k: string]: any }
export type ContentfulNode = {
  nodeType: string,
  data: ContentfulNodeData,
  __MONZO_INDEX__?: number,
  __MONZO_SUBTITLE_NODE__?: ContentfulNode,
}

export const getNodeType = (node: ContentfulNode) =>
  idx(node, _ => _.data.target.sys.contentType.sys.id)

export const getFieldsFromNode = (node: ContentfulNode): ?ContentfulNodeData =>
  idx(node, _ => _.data.target.fields)

export const getLocalisedFieldsFromField = (
  fields: ?ContentfulNodeData,
  locale: string,
): ?ContentfulNodeData =>
  fields &&
  Object.keys(fields).reduce((acc, fieldKey) => {
    acc[fieldKey] = fields[fieldKey][locale]
    return acc
  }, {})

export const getLocalisedFieldsFromNode = (
  node: ContentfulNode,
  locale: string,
) => {
  const fields = idx(node, _ => _.data.target.fields)
  return getLocalisedFieldsFromField(fields, locale)
}

export const getAssetURLFromSectionFields = (
  sectionFields: ?ContentfulNodeData,
  field: string,
  locale: string,
) => idx(sectionFields, _ => _[field][locale].fields.file[locale].url)

export const getAssetURLFromNodeField = (
  node: ContentfulNode,
  field: string,
  locale: string,
) => {
  const fields = getFieldsFromNode(node)
  return idx(fields, _ => _[field][locale].fields.file[locale].url)
}
